import React, {useEffect, useRef, useState} from "react";
import '../styles/navbar.css'
import {AiOutlineDown, AiOutlineMenu} from "react-icons/ai";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {BeatLoader} from "react-spinners";
import {GrUserAdmin} from "react-icons/gr";
import {MdSupervisorAccount} from "react-icons/md";
import {FaUser, FaUserSecret} from "react-icons/fa";
import {BiBell} from "react-icons/bi";
import ChangePass from "../components/modal/changePass";
import NotificationTooltip from "../components/NotificationTooltip";
import Api from "../Api/api";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../states/StateProvider";
import logo from '../assets/logo.jpg';

const Navbar = () => {

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const loginTimestamp = localStorage.getItem('loginTimestamp');
        const now = Date.now().toString();

        if (loginTimestamp && (now - loginTimestamp) >= 12 * 60 * 60 * 1000) { // 12 hours in milliseconds
            localStorage.clear();
            window.location.replace('/#/anmeldung');
        } else if (!loginTimestamp) {
            localStorage.setItem('loginTimestamp', now);
        }

    }, [location]);


    const [toggleMenu, setToggleMenu] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showNestedDropdown, setShowNestedDropdown] = useState(false); // State to control the nested dropdown visibility (Verwaltung)
    const [showMailserviceDropdown, setShowMailserviceDropdown] = useState(false); // State for Mailservice dropdown
    const [showNotificationTooltip, setShowNotificationTooltip] = useState(false);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const toggleNav = () => {
        setToggleMenu(!toggleMenu);
    };
    const [modal, setModal] = useState(false);
    const [version, setVersion] = useState('');
    const modalRef = useRef();

    const [{secretKey, portal, appointmentCount}, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8));

    useEffect(() => {
        Api().get('/version').then(res => {
            setVersion(Object.values(res.data[0])[0]);
        });

        // TESTING: Fetch appointment count for all users to test the bell icon
        // Original condition: if (user && user.role === 'Berater')
        if (user) { // FOR TESTING - Show for all users
            fetchAppointmentCount();
        }
    }, []);

    useEffect(() => {
        const changeWidth = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', changeWidth);
        return () => {
            window.removeEventListener('resize', changeWidth);
        };
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', (e) => {
            if (!modalRef.current.contains(e.target)) {
                setModal(false);
            }
        });
    }, []);

    function logout() {
        setLoading(true);
        setModal(!modal);

        // Clear notification tooltip flag
        const tooltipShownKey = `notificationTooltipShown_${user.email}_${new Date().toDateString()}`;
        localStorage.removeItem(tooltipShownKey);

        // Also clear any old notification tooltip entries
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('notificationTooltipShown_')) {
                localStorage.removeItem(key);
            }
        });

        localStorage.removeItem('user');
        localStorage.removeItem('admin');
        localStorage.removeItem('portal');
        localStorage.removeItem('hmFilter');
        localStorage.removeItem('dggFilter');
        setLoading(false);
        window.location.reload();
    }

    const VersionItem = (version) => {
        const parts = version.split('.');
        const lastPart = parts.pop();
        return (<span>
                {parts.join('.')}<span className='small-digit'>.{lastPart}</span>
            </span>);
    };

    const fetchAppointmentCount = async () => {
        try {
            const formData = new FormData();
            formData.append('email', user.email);

            const response = await Api().post('/sp_getOpenConsPlan', formData);
            if (response.status === 200) {
                const count = response.data ? response.data.length : 0;
                dispatch({
                    type: 'SET_APPOINTMENT_COUNT',
                    item: count
                });

                // Show tooltip on login if there are notifications and user hasn't seen it yet
                if (count > 0) {
                    const tooltipShownKey = `notificationTooltipShown_${user.email}_${new Date().toDateString()}`;
                    const hasSeenToday = localStorage.getItem(tooltipShownKey);

                    if (!hasSeenToday) {
                        // Show tooltip after a small delay
                        setTimeout(() => {
                            setShowNotificationTooltip(true);
                        }, 1000);
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching appointment count:', error);
            dispatch({
                type: 'SET_APPOINTMENT_COUNT',
                item: 0
            });
        }
    };

    const handleNotificationClick = () => {
        navigate('/open-appointments');
    };

    const handleCloseTooltip = () => {
        setShowNotificationTooltip(false);
    };

    return (<nav className='shadow-lg shadow-whiteDark' style={{zIndex: '59'}} ref={modalRef}
                 hidden={location.pathname.includes('anmeldung') || location.pathname.includes('registrieren') || location.pathname.includes('reset-password')}>
            <ul className="list">
                <li className='logo'>ProjektPortal</li>
                <li className='be-version-wrapper mt-1 mr-3 border border-y-0 border-l-0 pr-3 border-r-1 border-r-graph'> {VersionItem(version)}</li>
                <li className='fe-version-wrapper mt-2 mr-3 pr-3'>FE 3.16</li>
                <li className='time pr-4'/>
                {(toggleMenu || screenWidth > 1200) && (<>
                        <Link to={'/'} onClick={toggleNav}>
                            <li className={`items ${location.pathname === '/' && 'text-mainBlue'}  hover:text-mainBlue`}>Dashboard</li>
                        </Link>
                        <div className="dropdown">
                            <li className={`items ${(location.pathname === '/firmenprojekte-liste' || location.pathname === '/dienstleistungen' || location.pathname === '/storfalle') && 'text-mainBlue'}  hover:text-mainBlue`}>
                                Firmenprojekte <i className="dropdown-icon">▼</i>
                            </li>
                            <div className="dropdown-content">
                                <Link to={'/firmenprojekte-liste'} onClick={toggleNav}>
                                    <li className={`items ${location.pathname === '/firmenprojekte-liste' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                        Liste
                                    </li>
                                </Link>

                                {portal !== 'ruv' && (user.role === 'ExtDGG' || user.role === 'ManDGG' || user.role === 'Internal' || user.role === 'Controller') &&
                                    <Link to={'/dienstleistungen'} onClick={toggleNav}>
                                        <li className={`items ${location.pathname === '/dienstleistungen' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                            Dienstleistungen
                                        </li>
                                    </Link>}

                                <Link to={'/storfalle'} onClick={toggleNav}>
                                    <li className={`items ${location.pathname === '/storfalle' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                        Störfälle
                                    </li>
                                </Link>

                            </div>
                        </div>

                        {(user.role === 'ExtDGG' || user.role === 'ExtRUV') &&
                            <Link to={'/neu'} onClick={toggleNav}>
                                <li className={`items ${location.pathname === '/neu' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                    Neu
                                </li>
                            </Link>}

                        <div className="dropdown">
                            {(user?.role === 'Internal' || user?.role === 'Controller') &&
                                <li className={`items ${(location.pathname === '/WV-Historie' || location.pathname === '/mail-verlauf') && 'text-mainBlue'}  hover:text-mainBlue`}>
                                    Auditing <i className="dropdown-icon">▼</i>
                                </li>}
                            <div className="dropdown-content">
                                {(user?.role === 'Internal' || user?.role === 'Controller') && (
                                    <Link to={'/mail-verlauf'} onClick={toggleNav}>
                                        <li className={`items ${location.pathname === '/mail-verlauf' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                            Mailverlauf
                                        </li>
                                    </Link>)}
                                {(user?.role === 'Internal' || user?.role === 'Controller') && (
                                    <Link to={'/WV-Historie'} onClick={toggleNav}>
                                        <li className={`items ${location.pathname === '/WV-Historie' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                            WV-Historie
                                        </li>
                                    </Link>)}
                            </div>
                        </div>

                        <Link to={'/support'} onClick={toggleNav}>
                            <li className={`items ${location.pathname === '/support' && 'text-mainBlue'}  hover:text-mainBlue`}>Support</li>
                        </Link>

                        {/* Print Center Menu - iFEx Document Generation */}
                        {/*<div className="dropdown">*/}
                        {/*    <li className={`items ${(location.pathname.includes('/print-center')) && 'text-mainBlue'}  hover:text-mainBlue`}>*/}
                        {/*        Print Center <i className="dropdown-icon">▼</i>*/}
                        {/*    </li>*/}
                        {/*    <div className="dropdown-content">*/}
                        {/*        <Link to={'/print-center/platzhalter'} onClick={toggleNav}>*/}
                        {/*            <li className={`items ${location.pathname === '/print-center/platzhalter' && 'text-mainBlue'}  hover:text-mainBlue`}>*/}
                        {/*                Platzhalter*/}
                        {/*            </li>*/}
                        {/*        </Link>*/}
                        {/*        <Link to={'/print-center/dokumente'} onClick={toggleNav}>*/}
                        {/*            <li className={`items ${location.pathname === '/print-center/dokumente' && 'text-mainBlue'}  hover:text-mainBlue`}>*/}
                        {/*                Dokumente*/}
                        {/*            </li>*/}
                        {/*        </Link>*/}
                        {/*        <Link to={'/print-center/generieren'} onClick={toggleNav}>*/}
                        {/*            <li className={`items ${location.pathname === '/print-center/generieren' && 'text-mainBlue'}  hover:text-mainBlue`}>*/}
                        {/*                Generieren*/}
                        {/*            </li>*/}
                        {/*        </Link>*/}
                        {/*        /!* Settings - Super-Admin only *!/*/}
                        {/*        {(user?.isSAdmin === '1' || user?.role === 'Super Admin') && (*/}
                        {/*            <Link to={'/print-center/einstellungen'} onClick={toggleNav}>*/}
                        {/*                <li className={`items ${location.pathname === '/print-center/einstellungen' && 'text-mainBlue'}  hover:text-mainBlue`}>*/}
                        {/*                    Einstellungen*/}
                        {/*                </li>*/}
                        {/*            </Link>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/* Administration Menu - For Internal users with specific rights */}
                        <div className="dropdown">
                            {(((user?.role === 'Internal' && user.isUserAdmin === '1') || user.isICAdmin === '1' || user.isIMAdmin === '1' || user.isSAdmin === '1') && user?.role !== 'ExtDGG') && (
                                <li className='items hover:text-mainBlue'>
                                    Administration <i className="dropdown-icon">▼</i>
                                </li>)}

                            <div className="dropdown-content">
                                {/* Benutzerverwaltung - For users with user admin rights */}
                                {(user?.role === 'Internal' && (user.isUserAdmin === '1' || user.isSAdmin === '1')) && (
                                    <Link to={'/benutzerverwaltung'}>
                                        <li className={`items ${location.pathname === '/benutzerverwaltung' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Benutzerverwaltung
                                        </li>
                                    </Link>)}

                                {/* Footer - For users with user admin rights */}
                                {(user?.role === 'Internal' && (user.isUserAdmin === '1' || user.isSAdmin === '1')) && (<Link
                                        to={{
                                            pathname: '/admin-edit-footer', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/admin-edit-footer' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Footer
                                        </li>
                                    </Link>)}

                                {/* Mailservice Section - InfoCrawler and InfoMail */}
                                {(user?.role === 'Internal' && (user.isICAdmin === '1' || user.isIMAdmin === '1' || user.isSAdmin === '1')) && (
                                    <div className="dropdown"
                                         onMouseEnter={() => setShowMailserviceDropdown(true)}
                                         onMouseLeave={() => setShowMailserviceDropdown(false)}
                                    >
                                        <li className={`items ${(location.pathname === '/info-crawler' || location.pathname === '/info-mail') && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Mailservice <i className="dropdown-icon">▼</i>
                                        </li>
                                        {showMailserviceDropdown && <div className="dropdown-content-nested">
                                            <Link
                                                to={{
                                                    pathname: '/info-crawler', state: {data: user.isICAdmin},
                                                }}>
                                                <li className={`items ${location.pathname === '/info-crawler' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                    InfoCrawler
                                                </li>
                                            </Link>

                                            <Link to={'/info-mail'} onClick={toggleNav}>
                                                <li className={`items ${location.pathname === '/info-mail' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                    InfoMail
                                                </li>
                                            </Link>
                                        </div>}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Gestaltung (SA) Menu - Only for Super Admin */}
                        <div className="dropdown">
                            {(user?.role === 'Internal' && user.isSAdmin === '1') && (
                                <li className='items hover:text-mainBlue'>
                                    Gestaltung (SA) <i className="dropdown-icon">▼</i>
                                </li>)}

                            <div className="dropdown-content">
                                {/* Auswahltexte / WV Optionen */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (<Link
                                        to={{
                                            pathname: '/admin-edit-options', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/admin-edit-options' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Auswahltexte
                                        </li>
                                    </Link>)}

                                {/* Ansprechpartner Funktionen */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (<Link
                                        to={{
                                            pathname: '/admin-edit-functions', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/admin-edit-functions' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            AnsprP. Funktionen
                                        </li>
                                    </Link>)}

                                {/* Mail-Empfänger */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (<Link
                                        to={{
                                            pathname: '/admin-strings', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/admin-strings' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Mail-Empfänger
                                        </li>
                                    </Link>)}

                                {/* Potenzial-Parameter */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (<Link
                                        to={{
                                            pathname: '/potenzial-parameter', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/potenzial-parameter' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Potenzial-Parameter
                                        </li>
                                    </Link>)}

                                {/* Prozess Optionen */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (<Link
                                        to={{
                                            pathname: '/admin-edit-prozess-options', state: {data: user.isSAdmin},
                                        }}>
                                        <li className={`items ${location.pathname === '/admin-edit-prozess-options' && 'text-mainBlue'} hover:text-mainBlue`}>
                                            Prozess Optionen
                                        </li>
                                    </Link>)}

                                {/* Verwaltung - Nested dropdown for advanced settings */}
                                {(user?.role === 'Internal' && user.isSAdmin === '1') && (
                                        <div className="dropdown"
                                             onMouseEnter={() => setShowNestedDropdown(true)}
                                             onMouseLeave={() => setShowNestedDropdown(false)}
                                        >
                                            <li className={`items ${location.pathname === '/admin-edit' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                Optionen <i className="dropdown-icon">▼</i>
                                            </li>
                                            {showNestedDropdown && <div className="dropdown-content-nested">
                                                <Link
                                                    to={{
                                                        pathname: '/admin-edit-milestones',
                                                        state: {data: user.isSAdmin},
                                                    }}>
                                                    <li className={`items ${location.pathname === '/admin-edit-milestones' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                        Meilensteine
                                                    </li>
                                                </Link>
                                                <Link
                                                    to={{
                                                        pathname: '/admin-edit', state: {data: user.isSAdmin},
                                                    }}>
                                                    <li className={`items ${location.pathname === '/admin-edit' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                        MS-Schritte+Text
                                                    </li>
                                                </Link>
                                                <Link
                                                    to={{
                                                        pathname: '/admin-ui-kit', state: {data: user.isSAdmin},
                                                    }}>
                                                    <li className={`items ${location.pathname === '/admin-ui-kit' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                        UI Kit & Style Guide
                                                    </li>
                                                </Link>
                                                {user?.email === 'kbit.business@gmx.de' && (
                                                    <Link
                                                        to={{
                                                            pathname: '/logger', state: {data: user.isSAdmin},
                                                        }}>
                                                        <li className={`items ${location.pathname === '/logger' && 'text-mainBlue'} hover:text-mainBlue`}>
                                                            Logger
                                                        </li>
                                                    </Link>
                                                )}
                                            </div>}
                                        </div>
                                )}
                            </div>
                        </div>
                        <div className="dropdown">
                            {user?.role === 'Internal' &&
                                <li className={`items ${(location.pathname === '/admin-weekly-report' || location.pathname === '/email-reports') && 'text-mainBlue'}  hover:text-mainBlue`}>
                                    Reporting
                                    <i className="dropdown-icon">▼</i>
                                </li>}
                            <div className="dropdown-content">
                                {user?.role === 'Internal' && (
                                    <Link to={'/admin-weekly-report'} onClick={toggleNav}>
                                        <li className={`items ${location.pathname === '/admin-weekly-report' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                            Wochen-Report
                                        </li>
                                    </Link>)}
                                {user?.role === 'Internal' && (
                                    <Link to={'/email-reports'} onClick={toggleNav}>
                                        <li className={`items ${location.pathname === '/email-reports' && 'text-mainBlue'}  hover:text-mainBlue`}>
                                            Email-Reports
                                        </li>
                                    </Link>)}
                            </div>
                        </div>

                        {/* Notification Bell - Always show for Berater users */}
                        {user && appointmentCount > 0 ? (
                            <li className='notification-bell cursor-pointer' onClick={handleNotificationClick}>
                                <div className="relative">
                                    <BiBell size={'22px'} color={'#565c8c'}/>
                                    {/* Only show red badge when there are appointments */}
                                    {appointmentCount > 0 && (<span
                                            className="absolute -top-2 -right-2 bg-cancel text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                                            {appointmentCount}
                                        </span>)}

                                    {/* Notification Tooltip Popup */}
                                    <NotificationTooltip
                                        isOpen={showNotificationTooltip}
                                        onClose={handleCloseTooltip}
                                        appointmentCount={appointmentCount}
                                        user={user}
                                    />
                                </div>
                            </li>) : <li className='notification-bell' title={'Keine offenen Termine'}>
                            <div className="relative">
                                <BiBell size={'22px'} color={'#565c8c'}/>
                                {/* Only show red badge when there are appointments */}
                                {appointmentCount > 0 && (<span
                                        className="absolute -top-2 -right-2 bg-cancel text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                                                        {appointmentCount}
                                                    </span>)}
                            </div>
                        </li>}

                        <li className='userInfo cursor-pointer'>
                            {user?.role === 'Internal' ? (
                                <GrUserAdmin size={'30px'} color={'#565c8c'}/>) : user?.role === 'ExtRUV' ? (
                                <MdSupervisorAccount size={'35px'} color={'#3A46A9'}/>) : user?.role === 'ExtDGG' ? (
                                <MdSupervisorAccount size={'35px'} color={'#0a523f'}/>) : user?.role === 'ManRUV' ? (
                                <FaUser size={'30px'} color={'#565c8c'}/>) : user?.role === 'ManDGG' ? (
                                <FaUser size={'30px'} color={'#0a523f'}/>) : (user &&
                                <FaUserSecret size={'30px'} color={'#565c8c'}/>)}
                            <div>
                                <p className='pl-1' onClick={() => setModal(!modal)}>
                                    {user?.fullname}
                                </p>
                                <p onClick={() => setModal(!modal)} className='text-xs pl-1'>
                                    {user?.email}
                                </p>
                            </div>
                            <p className='cursor-pointer m-1'>
                                <AiOutlineDown onClick={() => setModal(!modal)}/>
                            </p>
                        </li>
                    </>)}
                <img src={logo} alt="Logo" className="logo-image"/>
            </ul>
            <div className={modal ? 'modal-logout' : 'hidden'}>
                <ChangePass/>
                <button
                    onClick={logout}
                    className='text-left p-1 hover:text-red'
                >
                    {!loading ? 'Ausloggen' : <BeatLoader size={10} color={'#000000'}/>}
                </button>
            </div>
            <button onClick={toggleNav} className="btn"><AiOutlineMenu/></button>
        </nav>)
}

export default Navbar;
